<mat-card class="w-full h-full">
	<mat-card-header class="gap-2">
		<mat-card-title
			><h3>{{ title() | translate }}</h3>
		</mat-card-title>
		<div class="card-title-actions dense-min">
			<mat-button-toggle-group [hideMultipleSelectionIndicator]="true" [hideSingleSelectionIndicator]="true" [multiple]="false" [value]="undefined" appearance="standard">
				<!--				add new pair-->
				<mat-button-toggle
					#addPairButton
					(click)="addEmptyPair(addPairButton)"
					[disableRipple]="true"
					[disabled]="!isObjectPairsValid$()"
					[matTooltip]="'components.simple-object-builder.add-tooltip' | translate"
					[ngClass]="{
						'hover:bg-gray-100 text-gray-500': !isObjectPairsValid$(),
						'hover:bg-primary-100 text-blue-800': isObjectPairsValid$(),
					}"
					value="add"
				>
					<i class="fa-duotone fa-plus"></i>
				</mat-button-toggle>
				<!--				preview output object-->
				<mat-button-toggle
					#previewButton
					(click)="showPreview(previewButton, previewOutputObject, $event)"
					[disableRipple]="true"
					[matTooltip]="'components.simple-object-builder.preview-tooltip' | translate"
					class="hover:bg-primary-100 text-primary-500"
					value="preview"
				>
					<i class="fa-duotone fa-eye"></i>
				</mat-button-toggle>
				<!--				reset object pairs-->
				<mat-button-toggle
					#resetButton
					(click)="resetObjectPairs(resetButton)"
					[disableRipple]="true"
					[matTooltip]="'components.simple-object-builder.reset-tooltip' | translate"
					class="hover:bg-red-100 text-red-500"
					value="reset"
				>
					<i class="fa-duotone fa-undo"></i>
				</mat-button-toggle>
			</mat-button-toggle-group>
		</div>
	</mat-card-header>
	<mat-divider class="my-2" />
	<mat-card-content class="h-available">
		<div (cdkDropListDropped)="reorderPairs($event)" cdkDropList class="ph-list">
			@for (pair of objectPairs$(); track pair.index) {
				<div class="ph-list-row" cdkDrag>
					<!-- --------------------------- Reorder handle ---------------------------- -->
					<fa-icon cdkDragHandle iconName="bars" faStyle="duotone" size="lg" class="cursor-move" />
					<!-- --------------------------- Actual content ---------------------------- -->
					<span class="ph-list-row-content aura-light-blue">
						<p-floatLabel>
							<p-dropdown
								id="selected_placeholder"
								class="aura-light-blue w-full h-available items-center"
								styleClass=" aura-light-blue w-full h-available items-center"
								[overlayOptions]="{appendTo: 'body', styleClass: 'ph-list-row-content-dd aura-light-blue'}"
								[group]="true"
								[options]="placeholderOptions$()"
								optionLabel="label"
								[ngModel]="pair.selected_placeholder"
								(ngModelChange)="
									$event.source === 'const' ? patchPair(pair, {selected_placeholder: get_CUSTOM_DATA_OPTIONS(), data_label: ''}) : patchPair(pair, {selected_placeholder: $event, data_label: $event.label})
								"
								[filter]="true"
								filterBy="label"
								[placeholder]="selectPlaceholderPrompt() | translate"
							>
								<ng-template pTemplate="filter"></ng-template>
								<ng-template let-group pTemplate="group">
									@if (group.label && group.icon) {
										<mat-divider class="my-1" />
										<h5 class="font-bold text-gray-700 flex items-center gap-1">
											<mat-icon>{{ group.icon }}</mat-icon>
											{{ group.label | translate }}
										</h5>
										<mat-divider class="my-1" />
									}
								</ng-template>

								<ng-template pTemplate="selectedItem">
									<span class="font-bold text-primary-500"> {{ pair.selected_placeholder?.label | translate }}</span>
								</ng-template>

								<ng-template let-ph pTemplate="item" [ngAs]="ObjectBuildAvailablePlaceholder">
									<span class="item-row flex items-center gap-1">
										@if (ph.icon) {
											<mat-icon>{{ ph.icon }}</mat-icon>
										}
										@switch (ph.source) {
											@case ('const') {
												<span class="font-bold text-primary-500">
													{{ ph.label | translate }}
												</span>
											}
											@case ('meta_tag') {
												{{ ph.label | translate }}
											}
											@case ('user_info') {
												{{ ph.label | translate }}
											}
										}
									</span>
								</ng-template>
							</p-dropdown>

							<label for="selected_placeholder">{{ 'components.simple-object-builder.data-source' | translate }}</label>
						</p-floatLabel>

						@if (pair?.selected_placeholder) {
							<!-- Input to enter the data label -->
							<p-floatLabel>
								<input
									#data_label_input
									required
									pInputText
									id="data_label"
									class="revert-layer primeng-element"
									[(ngModel)]="pair.data_label"
									[ngClass]="{
										'ng-invalid ng-dirty': pair.data_label === '',
									}"
								/>
								<label for="data_label">{{ 'components.simple-object-builder.data-description' | translate }}</label>
							</p-floatLabel>
						}

						@if (pair?.selected_placeholder?.source === 'const') {
							<!-- Input to enter the key
							TODO:	in typing validate that there is no same text in the other data pairs 
							-->
							<p-floatLabel>
								<input
									#const_key_input
									required
									pInputText
									id="const-key"
									[(ngModel)]="pair.value"
									[ngClass]="{
										'ng-invalid ng-dirty': pair.value === '',
									}"
								/>
								<label for="const-key">{{ 'components.simple-object-builder.data-title' | translate }}</label>
							</p-floatLabel>
						}
					</span>

					<!-- ---------------------------- deletePair Button ---------------------------- -->
					<button mat-icon-button [matTooltip]="'components.simple-object-builder.remove-tooltip' | translate" (click)="deletePair(pair.index)" class="hover:text-red-500 bg-transparent">
						<fa-icon faStyle="duotone" iconName="circle-minus" size="xl" class="hover:text-red-500" />
					</button>
				</div>
			}
		</div>
	</mat-card-content>

	<mat-divider class="mt-2" />
	<mat-card-actions class="py-2 w-full h-max justify-around items-center min-h-0">
		<!-- ---------------------------- Cancel Button ---------------------------- -->
		<button (click)="onCancel()" color="warn" mat-stroked-button>
			{{ 'components.simple-object-builder.cancel-button' | translate }}
		</button>
		<!-- ----------------------------- Save Button ----------------------------- -->
		<button (click)="saveObject(previewOutputObject)" [disabled]="!isObjectPairsValid$()" color="primary" mat-raised-button>
			{{ 'components.simple-object-builder.save-tooltip' | translate }}
		</button>
	</mat-card-actions>
</mat-card>

<!--Overlays-->
<p-overlayPanel #previewOutputObject appendTo="body" class="aura-light-blue">
	<!--	<pre>{{ object() | json }}</pre>-->
	@defer (on viewport) {
		<mat-card>
			<mat-card-header class="p-1.5">
				<mat-card-title>
					<h3>{{ 'components.simple-object-builder.preview' | translate }}</h3>
				</mat-card-title>
				<!--		Action: copy to clipboard		 -->
				<div id="actions" class="card-title-actions dense-min">
					<mat-button-toggle-group [value]="undefined" appearance="standard" [multiple]="false" [hideSingleSelectionIndicator]="true" [hideMultipleSelectionIndicator]="true">
						<mat-button-toggle
							#copyButton
							[disableRipple]="true"
							value="copy"
							[cdkCopyToClipboard]="previewObject$() | json"
							(cdkCopyToClipboardCopied)="
								toastService.open({
									message: 'components.simple-object-builder.copy-success',
									type: 'success',
									life: 2500,
									styleClass: 'text-center',
								})
							"
							pTooltip="{{ 'components.simple-object-builder.copy-tooltip' | translate }}"
							class="hover:bg-primary-100 text-primary-500"
						>
							<i class="fa-duotone fa-copy"></i>
						</mat-button-toggle>
					</mat-button-toggle-group>
				</div>
			</mat-card-header>
			<mat-divider />
			<mat-card-content class="p-1">
				<div class="output-object-preview-wrapper">
					<ngx-json-viewer [json]="wrappedObjectWithData$()" />
				</div>
			</mat-card-content>
		</mat-card>
	} @placeholder {
		<p-skeleton />
	}
</p-overlayPanel>
